import { Goal, LifeArea } from '@griply/types';

export type FilterLocalizedLifeAreasOptions = {
  goals: Goal[];
  showEmptyLifeAreas: boolean;
};

export const filterLocalizedLifeAreas = (
  lifeAreas: LifeArea[],
  { goals, showEmptyLifeAreas }: FilterLocalizedLifeAreasOptions,
): LifeArea[] =>
  lifeAreas.filter(
    ({ id, archivedAt }) =>
      !archivedAt &&
      (showEmptyLifeAreas ||
        goals.some(
          ({ lifeAreaId, parentIds }) =>
            !parentIds?.length && lifeAreaId === id,
        )),
  );
